define('viewmodels/pages/cash/methods/boku/AddBokuDepositViewModel',['knockout'], function (ko) {

    function AddBokuDepositViewModel (BokuDepositAmountStep, formFields, depositPage, depositModel, Wizard) {

        var methodModel = depositModel.methodModel(),
            phoneNumberField = formFields.phoneNumberField(methodModel.phoneNumber);

        phoneNumberField.prefix.isDisabled = ko.observable(true);

        this.wizardModel = new Wizard({
            steps: [
                {
                    field: phoneNumberField,
                    label: depositPage.findFieldByName('boku_phone_number_label'),
                    type: 'phoneNumber'
                },
                new BokuDepositAmountStep(depositModel)
            ]
        });
    }

    AddBokuDepositViewModel.prototype.getView = function () {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return AddBokuDepositViewModel;
});


